import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import NotificationsSettingsPage, { getDefaultPageUI } from "components/pages/NotificationsSettingsPage";
import { getDefaultAddPhone } from "components/workflows/AddPhoneContactMethodModalWorkflow";
import Classes, { ContactInfo } from "model";

export default function CaptureNotifiPhoneActive(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, controller);

    const newInfo = ContactInfo.init({
        id: ContactInfo.nextID(),
        isPrimary: "false",
        isConfirmed: "true",
        value: "(231) 256-7890",
        userEnteredActivationCode: "1270837"
    });

    const modalData = BCMSStateManagerCRUD.init(getDefaultAddPhone("addPhoneWorkflow", undefined))
        .update([ "data", "info", "value" ], "231-256-7890")
        .update([ "data", "unconfirmedContacts" ], [ newInfo ])
        .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "modal", "id" ], "AddContactMethodModal")
        .update([ "modal", "data" ], { workflowType: "addPhoneWorkflow", values: modalData, step: 1 })
        .submit();

    return <NotificationsSettingsPage ui={ ui } />
}